export default {
  track1: {
    label: 'Track I',
    color: 'green',
  },
  track2: {
    label: 'Track II',
    color: 'blue',
  },
  workshop1: {
    label: 'WS room I',
    color: 'navy',
    isWorkshop: true,
  },
  workshop2: {
    label: 'WS room II',
    color: 'brown',
    isWorkshop: true,
  },
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/tracks.js